<template>
  <el-tabs
    type="border-card"
    style="margin-bottom: 20px"
    v-model="activeTab"
    @tab-click="clickTab"
  >
    <slot></slot>
  </el-tabs>
</template>

<script>

export default {
  name: 'form-tabs',
  props: {
  },
  data () {
    return {
      activeTab: 'basic'
    }
  },
  created () {
  },
  mounted () {
    this.setTab(this.$router.currentRoute.hash)
  },
  computed: {
  },
  methods: {
    setTab (hash) {
      if (hash && hash.startsWith('#tabs-')) {
        this.activeTab = hash.substring(6) || this.activeTab
      }
    },
    clickTab (e) {
      let hash = null
      if (e.name) {
        hash = '#tabs-' + e.name
      }
      if (hash !== this.$router.currentRoute.hash) {
        this.$router.push({
          path: this.$router.currentRoute.path,
          hash: hash,
          meta: { noRefer: true }
        })
      }
    }
  },
  watch: {
    '$route.hash' (v) {
      this.setTab(v)
    }
  }
}
</script>
